<template>
    <div v-if="guideDisplay === true" class="guide__background">
    </div>
    <div class="IntroCard" v-if="Guid?.items" :class="centerGuide()">
        <div @click="exitGuide()" class="IntroCard__cancelBtn">{{ Guid.messages.cancel }}</div>
        <swiper
            :slides-per-view="currentSlide"
            :modules="modules"
            pagination
            @swiper="onSwiperInit"
        >

            <swiper-slide v-for="(item, index) in Guid.items" :key="index">
                <div class="slide">
                    <img :src="item.img" alt="" v-if="item.img">
                    <div class="slide__label" v-if="item.title">{{ item.title }}</div>
                    <span class="slide__description" v-if="item.text">{{ item.text }}</span>
                    <span class="slide__subtitle" v-if="item.subTitle">{{ item.subTitle }}</span>
                    <ABtn :label="item.btn" v-if="item.btn" class="flat outlined" color="#fff"
                          @click.prevent="nextSlide(index)"></ABtn>
                </div>
            </swiper-slide>
        </swiper>
    </div>
</template>

<script>
// https://i.imgur.com/zGK6S1B.png reference
import {pageGuid} from "../../composables/pageGuid";
import {Swiper, SwiperSlide, useSwiper} from 'swiper/vue';
import {Navigation, Pagination} from "swiper";
import {ABtn} from "../ui";

import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/pagination';
import {ref} from "vue";


export default {
    name: "IntroCard",
    components: {
        Swiper,
        SwiperSlide,
        ABtn,
    },
    setup() {
        const {Guid} = pageGuid();
        const currentSlide = ref(1);
        const swiper = ref(null);
        const onSwiperInit = (s) => {
            swiper.value = s
        }
        const guideDisplay = ref(false);
        const nextSlide = (index) => {
            swiper.value.slideNext();
            if (index === 0) {
                guideDisplay.value = true;
            }
        }

        const centerGuide = () => {
            return {
                'centerGuide': guideDisplay.value === true
            };
        };
        const exitGuide = () => {
            guideDisplay.value = false;

            if (swiper.value) {
                swiper.value.slideTo(0);
            }
        }

        return {
            swiper,
            onSwiperInit,
            currentSlide,
            nextSlide,
            Guid,
            modules: [Navigation, Pagination],
            guideDisplay,
            centerGuide,
            exitGuide
        }
    }
}
</script>

<style lang="scss" scoped>
.IntroCard {
    border-radius: 6px;
    background-color: var(--c-secondary-200);
    color: #fff;
    padding: 40px;
    margin: 30px 0;

    &__cancelBtn {
        position: absolute;
        top: 24px;
        right: 24px;
        font-weight: 400;
        font-size: 14px;
        line-height: 20px;
        text-transform: capitalize;
    }

    .slide {
        display: flex;
        align-items: center;
        justify-content: center;
        flex-direction: column;
        text-align: center;
        padding-bottom: 30px;

        img {
            margin-bottom: 25px;
        }

        &__label {
            font-weight: 600;
            font-size: 32px;
            line-height: 38px;
            margin-bottom: 18px;
        }

        &__description {
            font-weight: 400;
            font-size: 14px;
            line-height: 20px;
            margin-bottom: 3px;
        }

        &__subtitle {
            font-weight: 600;
            font-size: 16px;
            line-height: 24px;
            margin-bottom: 25px;
        }
    }

    ::v-deep .swiper-pagination-bullet-active {
        background-color: #fff;
    }

    ::v-deep .swiper-pagination {
        bottom: 0;
    }
}

.centerGuide {
    position: fixed;
    top: 50%;
    left: 50%;
    right: 10%;
    transform: translate(-50%, -50%);
    z-index: 999;
}

.guide__background {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: rgba(0, 0, 0, 0.5);
    z-index: 998;
}

.IntroCard__cancelBtn {
    cursor: pointer;
}
</style>